import React from "react";
import clsx from "clsx";

import { IRecipientCard } from "./RecipientCard";
import Avatar from "../Avatar";
import Typograpy from "../Typography";
import Button from "../Button";
import { EyeIcon } from "../../../assets/Icons";
import { useNavigate } from "react-router-dom";

const RecipientCard: React.FunctionComponent<IRecipientCard.IProps> = ({
  firstName,
  // lastName,
  accNo,
  onButtonClick,
  cardContainerClassname,
  icon,
  id,
  name,
  bankAccountCountry,
  acNumber,
}) => {
  const navigate = useNavigate();
  return (
    <div
      className={clsx(
        "py-3 md:py-5 pl-5 hover:bg-blue-100 bg-white my-5 md:pl-8 pr-7 md:pr-12 w-full flex justify-center items-center rounded-[6px] transition-all shadow-xl",
        cardContainerClassname,
      )}
    >
      <Avatar
        textClassname="!text-[24px] md:text-[34px]"
        customClassname="w-[54px] h-[54px]  md:w-[74px] md:h-[74px]"
        name={`${firstName.charAt(0)}`}
      />
      <div className="ml-10 flex flex-col gap-1.5 flex-1">
        <Typograpy tagType="span" className="text-xl" text={`${firstName}`} />
        <Typograpy tagType="span" className="text-sm text-grey-700">
          {bankAccountCountry}
        </Typograpy>
        <div className="flex gap-1">
          <Typograpy tagType="span" className="text-[10px] font-bold">
            A/C No.
          </Typograpy>
          <Typograpy tagType="span" className="text-[10px]">
            {accNo}
          </Typograpy>
        </div>
      </div>
      <div
        onClick={() => {
          localStorage.setItem("recipient_id", id);
          localStorage.setItem("recipientName", name);
          localStorage.setItem("AcNumber", acNumber);
          navigate("/recipient-profile", { state: { userID: id } });
        }}
        className="mr-8 transition-all cursor-pointer hover:scale-125"
      >
        <EyeIcon />
      </div>
      <Button
        className="recipient-button w-[40px] h-[40px] md:w-[76px] md:h-[76px] rounded-full opacity-50 bg-[transparent] border-[3px] border-primary hover:bg-blue-200 hover:scale-105 transition-all"
        onClickHandler={() => {
          localStorage.setItem("recipient_id", id);
          localStorage.setItem("recipientName", name);
          localStorage.setItem("AcNumber", acNumber);
          onButtonClick();
        }}
      >
        {icon}
      </Button>
    </div>
  );
};

export default RecipientCard;
